export const removeNonAscii = text => {
  return text.replace(/[^\x00-\x7F]/g, "");
}